'use client'

import { useCallback, useMemo, useState } from 'react'

// Checked-in listing payload: `features/blog/data/blog-posts.json`.
import blogData from '@/features/blog/data/blog-posts.json'
import { BLOG_PAGE_SIZE } from '@/features/blog/constants/blog.constants'
import { categoryMatchesFilter } from '@/features/blog/constants/blog-filters'
import type { BlogFilterId, BlogPostsDocument } from '@/features/blog/types/blog.types'

const allPosts = (blogData as BlogPostsDocument).posts

export function useBlogListing() {
  const [filter, setFilter] = useState<BlogFilterId>('all')
  const [page, setPage] = useState(1)

  const filtered = useMemo(
    () => allPosts.filter((p) => categoryMatchesFilter(p.category, filter)),
    [filter],
  )

  const totalPages = Math.max(1, Math.ceil(filtered.length / BLOG_PAGE_SIZE))
  const currentPage = Math.min(page, totalPages)
  const sliceStart = (currentPage - 1) * BLOG_PAGE_SIZE
  const posts = filtered.slice(sliceStart, sliceStart + BLOG_PAGE_SIZE)

  const onFilterChange = useCallback((next: BlogFilterId) => {
    setFilter(next)
    setPage(1)
  }, [])

  return {
    filter,
    onFilterChange,
    grid: {
      posts,
      isEmpty: posts.length === 0,
      currentPage,
      totalPages,
      onPageChange: setPage,
    },
  }
}
